import { buildMenuTooltip } from '../../../helpers/menuHelpers'
import { approvalActions } from '../helpers'

const phaseIsOnlyPlaceholders = (phase) =>
  !phase.items ||
  !phase.items.length ||
  (!phase.items.find((p) => !p.isPlaceholder) && phase.items.length === 1)

const shouldDisableDelete = (phase) =>
  phase.isLocked ||
  phase.isActive ||
  phase.status === 'approved' ||
  phaseIsOnlyPlaceholders(phase)

const shouldDisableTransfer = (approval, currentUser, phase) =>
  !approval.toUser ||
  approval.toUser.id === currentUser.id ||
  approval.proxyUser !== undefined ||
  phase.status !== 'pending'

function defaultMenu(phase) {
  let deleteApprovalTooltip = false
  if (phase.isLocked) {
    const tooltipText =
      'This approver cannot be removed because it is in a locked phase.'
    deleteApprovalTooltip = buildMenuTooltip(tooltipText)
  }

  return [
    {
      title: 'Remove approver',
      action: approvalActions.Delete,
      disabled: shouldDisableDelete(phase),
      tooltip: deleteApprovalTooltip,
    },
  ]
}

function activePhaseMenu(approval, currentUser, phase) {
  if (!phase.isActive) {
    return []
  }
  return [
    {
      title: 'Transfer approval to me',
      action: approvalActions.Transfer,
      disabled: shouldDisableTransfer(approval, currentUser, phase),
    },
  ]
}

export const buildMenu = (approval, currentUser, phase, workflowLocation) => {
  if (workflowLocation === 'workflowPopover') {
    return [...activePhaseMenu(approval, currentUser, phase)]
  }

  return [
    ...defaultMenu(phase, workflowLocation),
    ...activePhaseMenu(approval, currentUser, phase),
  ]
}

export default {
  buildMenu,
  phaseIsOnlyPlaceholders,
  shouldDisableDelete,
}
